import React, { useState, useEffect } from "react";
import axios from "axios";
import Deli_Logo from "../assets/Deli_Logo.svg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth0 } from "@auth0/auth0-react";

import PopUp5 from "../components/PopUp5";
import PopUp6 from "../components/PopUp6";
import PopUp7 from "../components/PopUp7";
import { jwtDecode } from "jwt-decode";
import LoadingSpinner from "../components/LoadingSpinner";

import { verifyCardOnFile } from "../utils/apiHandler";

const Step3 = () => {
  const navigate = useNavigate();
  const { getIdTokenClaims,isAuthenticated,getAccessTokenSilently } = useAuth0();
  const [brokerName, setName] = useState("");
  const [brokerEmail, setEmail] = useState("");
  const [popUp, setPopUp] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [brokername, setBrokername] = useState("");
  const [isTokenChecked, setIsTokenChecked] = useState(false);



  useEffect(() => {
    const authenticate = async () => {
      let idTokenClaims;
      let attempts = 0;
  
      // Attempt to refresh the token up to 3 times
      while (!idTokenClaims && attempts < 3) {
        await getAccessTokenSilently({cacheMode: 'off'});

        idTokenClaims = await getIdTokenClaims();
        attempts++;
      }
  
      if (idTokenClaims) {
        const idToken = idTokenClaims.__raw;
        const decodedToken = jwtDecode(idToken);

        setBrokername(decodedToken?.broker_name);
  
        if (decodedToken?.broker_verified) {
          var paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
          if(await verifyCardOnFile(idToken, paymentPlan))
            navigate("/chat");
        }

        setTimeout(() => {
          setIsTokenChecked(true);
        }, 2000);
      } else {
        console.error("Failed to refresh token after 3 attempts");
      }
    };
  
    authenticate();
  }, [getIdTokenClaims, isAuthenticated, getAccessTokenSilently, navigate]);
  

  if (!isTokenChecked || isLoading) {
    return <LoadingSpinner />; // Show the loading spinner when not authenticated and loading
  }

  const emailAuthentication = async () => {
    if (!brokerName || !brokerEmail) {
      toast.error("Please enter both broker name and email");
      return;
    }

    setIsLoading(true);
    try {
      const idTokenClaims = await getIdTokenClaims();

      const idToken = idTokenClaims.__raw;
      const response = await axios.patch(
        `https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/user`,
        {
          broker_contact_name: brokerName,
          broker_email: brokerEmail,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Broker information saved successfully");
        var paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
        if(await verifyCardOnFile((await getIdTokenClaims()).__raw, paymentPlan))
          navigate("/chat");
      } else {
        toast.error("Failed to save broker information");
      }
    } catch (error) {
      // console.error(error);
      toast.error(
        "An error occurred while saving broker information. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
<div className="h-[95vh] overflow-h-scroll">
      {popUp <= 3 && popUp !== 0 && (
        <div className="absolute top-0 left-0 opacity-90 bg-[#3D4F6D] w-full h-screen z-20"></div>
      )}
      {popUp === 1 && <PopUp5 setPopUp={setPopUp} />}
      {popUp === 2 && <PopUp6 setPopUp={setPopUp} />}
      {popUp === 3 && <PopUp7 setPopUp={setPopUp} />}

      <div className="flex justify-center items-center w-full py-12">
        <div className="">
          <div className="flex justify-center items-center">
            <img src={Deli_Logo} alt="" />
          </div>

          <div className="mt-8">
            <div className="sm:max-w-[60%] max-w-full sm:px-3 px-5 mx-auto flex items-center justify-center flex-col">
              <h1 className="text-black tracking-wider font-bold md:text-7xl leading-tight text-center sm:text-6xl text-5xl">
                Welcome
              </h1>
              <p className="text-[14px] font-semibold py-3">
                What Utah brokerage are you with?
              </p>
            </div>

            <div className="flex items-center gap-4 justify-center my-4">
              <div className="w-20 h-1 bg-[#0062FF] rounded-full"></div>
              <div className="w-20 h-1 bg-[#0062FF] rounded-full"></div>
              <div className="w-20 h-1 rounded-full">
                <div className="w-full h-full bg-[#0062FF] rounded-full fade-animation"></div>
              </div>
            </div>
            <div className="md:max-w-[63%] max-w-full px-3 mx-auto mt-4">
              <div className="mb-6">
                <div className="bg-[#0062FF2B] shadow-xl font-bold rounded-xl">
                  <h1 className="text-center text-[1.9rem] py-2">
                    {brokername ? brokername : ""}
                  </h1>
                </div>
                {/* Input boxes */}
                <div className="max-w-full py-3 mt-4 px-4 rounded-full border-[#7E8799] border bg-[#ffff] ">
                  <input
                    onChange={(e) => setName(e.target.value)}
                    className="w-full outline-white border-none focus:outline-none focus:border-none"
                    type="text"
                    placeholder="Broker Contact Name"
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="max-w-full py-3 mt-6 px-4 rounded-full border-[#7E8799] border bg-[#ffff] ">
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full outline-white border-none focus:outline-none focus:border-none"
                    type="email"
                    placeholder="Broker Contact Email"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              {/* Button */}
              <div onClick={emailAuthentication}>
                <Button
                  text={isLoading ? "Loading..." : "Continue"}
                  bgColor="bg-[#0062ff]"
                  textColor="text-white"
                  onClick={emailAuthentication}
                  disabled={isLoading}
                />
              </div>
              {/* Footer Box */}
              <div className="w-full bg-[#0062FF2B] shadow-xl border lg:mt-6 sm:mt-4  mt-6 py-4 rounded-lg">
                <h1 className="max-w-[90%] text-center mx-auto">
                  DELI makes it fun to search for a home and allows you to
                  really personalize your requirements and wants for your home
                  purchase.
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3;
